exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".App .view-container{padding-top:.75rem;padding-left:11rem}.App .primary-view{width:100%;max-width:450px}.App .insecure-scheme{width:100%;text-align:center;margin:0 auto;font-family:Lato,sans-serif;font-weight:300;position:absolute;top:40%;margin-top:-1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/App.scss
// module id = 227
// module chunks = 0